import React, { useRef, useState } from 'react';
import cx from 'classnames';
import styled from 'styled-components';
import { DropdownNearby } from 'components/components/atoms';
import useBreakpoint from 'utils/hooks/useBreakpoint';

const Container = styled.div`
  ${({ isMobile }) => (isMobile ? 'width: 100%;' : 'width: 13.200rem;')}
`;
const ListContainer = styled.div`
  ${({ isMobile }) => (isMobile ? 'max-height: 25rem;' : 'max-height: 27rem;')}
`;

const ServiceList = styled.div`
  display: inline-grid;
  column-gap: 5rem;
`;

const Button = styled.div`
  margin-bottom: 0.5rem;
  &:nth-last-child(1) {
    margin-bottom: 0rem;
  }
`;

const ServiceDropdown = (props) => {
  const {
    serviceFilter = [],
    selectedcount,
    onServiceChange,
    withSelectClick = true,
    active: activeProp,
    setActive: setActiveProp,
    items,
    showNewSchemaColor,
    newSchemaColorHexaCode,
    newSchemaTextColorHexaCode,
  } = props;

  const breakpoint = useBreakpoint(
    typeof window !== 'undefined' && window.innerWidth,
  );

  const isMobile = ['sm', 'xs'].includes(breakpoint);
  const ref = useRef();
  const [activeState, setActiveState] = useState(false);

  const active = activeProp || activeState;
  const setActive = setActiveProp || setActiveState;

  const ServicesList = serviceFilter.sort((a, b) =>
    a.tagName.toLowerCase() > b.tagName.toLowerCase() ? 1 : -1,
  );

  let length = selectedcount.length;

  return (
    <Container
      isMobile={isMobile}
      onBlur={() => {
        setTimeout(() => {
          if (ref && ref.current) {
            const containsFocusedElement = ref.current.contains(
              document.activeElement,
            );
            if (!containsFocusedElement) {
              setActive(false);
            }
          }
        }, 100);
      }}
      ref={ref}
    >
      <DropdownNearby
        className='mr-20'
        label={
          <>
            {"What's Nearby "}
            {/* <span className="ml-2">
              {selectedcount.length > 0 ? selectedcount.length : items.length}
            </span> */}
          </>
        }
        withSelectClick={withSelectClick}
        active={active}
        setActive={setActive}
        dropdownDescription={'Nearby Services'}
        darkBlue={!showNewSchemaColor}
        showNewSchemaColor={showNewSchemaColor}
        newSchemaColorHexaCode={newSchemaColorHexaCode}
        newSchemaTextColorHexaCode={newSchemaTextColorHexaCode}
        style={!isMobile ? { maxWidth: '13.200rem' } : undefined}
        rotateChevronDown={true}
      >
        <ListContainer
          className='overflow-hidden lg:flex w-full md:w-48 pl-1 pr-8'
          isMobile={isMobile}
        >
          <ServiceList>
            <Button
              tabIndex={0}
              role='checkbox'
              aria-checked={
                !selectedcount.find((sC) => {
                  return sC.tagName !== 'All';
                })
              }
              className='relative flex items-center tracking-normal text-sm whitespace-nowrap'
              key={'All'}
              onClick={(e) => {
                onServiceChange({ tagName: 'All' });
              }}
              onKeyDown={(e) => {
                if (e.key === ' ' || e.key === 'Enter') {
                  e.preventDefault();
                  onServiceChange({ tagName: 'All' });
                }
              }}
            >
              <div
                className={cx(
                  'w-4 h-4 mr-2 rounded-full border-2 border-white',
                  {
                    'bg-white': !selectedcount.find((sC) => {
                      return sC.tagName !== 'All';
                    }),
                    'bg-transparent': selectedcount.find((sC) => {
                      return sC.tagName !== 'All';
                    }),
                  },
                )}
              ></div>
              <span>All</span>
            </Button>

            {ServicesList.map((service, index) => (
              <Button
                role='checkbox'
                aria-checked={selectedcount.find((sC) => {
                  return sC.tagName === service.tagName;
                })}
                className='relative flex items-center tracking-normal text-sm whitespace-nowrap'
                key={service.id}
                onClick={(e) => {
                  onServiceChange(service);
                }}
                onKeyDown={(e) => {
                  if (e.key === ' ' || e.key === 'Enter') {
                    e.preventDefault();
                    onServiceChange(service);
                  }
                }}
                tabIndex='0'
                aria-label={service.tagName + ' service'}
              >
                <div
                  className={cx(
                    'w-4 h-4 mr-2 rounded-full border-2 border-white',
                    {
                      'bg-white': selectedcount.find((sC) => {
                        return sC.tagName === service.tagName;
                      }),
                      'bg-transparent': selectedcount.find((sC) => {
                        return sC.tagName === 'All';
                      }),
                    },
                  )}
                ></div>

                <span>
                  {service.tagName.length > 40
                    ? service.tagName.substring(0, 37) + '...'
                    : service.tagName}
                </span>
              </Button>
            ))}
          </ServiceList>
        </ListContainer>
      </DropdownNearby>
    </Container>
  );
};

export default ServiceDropdown;
